import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import HomePage from '../views'
import LoginPage from '../views/login'
import Console from '../views/console'
import VideoCreate from '../views/clone/videoCreate';
import Clone from '../views/clone';
import Home from '../views/home';
import TwinCreate from '../views/clone/twinCreate';
import Account from '../views/setting'
import Video from '../views/video';
import Voice from '../views/voice';
import Template from '../views/clone';
import Pricing from '../views/pricing';
import ProfessionChat from '../views/employee';

const Routers = () => {

	return (
		<Router>
			
			<Routes>
				
				<Route path="/" element={<HomePage />} />


				<Route path="/console" element={<Console />} >
					<Route path="clone" element={<Clone />} />
						
					<Route path='clone/template' element={<Template />} />
					<Route path="clone/templateCreate" element={<TwinCreate />} />
					<Route path="clone/videoCreate" element={<VideoCreate />} />
					<Route path="home" element={<Home />} />
					<Route path="account" element={<Account />} />
					<Route path="video" element={<Video />} />
					<Route path="voice" element={<Voice />} />
					<Route path="employee/:profession" element={<ProfessionChat />} />
					
					
				</Route>

				<Route path="/pricing" element={<Pricing />} />
				<Route path="/login" element={<LoginPage />} ></Route>

			</Routes>
		</Router>
	)

}

export default Routers